export const graphMulti = {
    rolesCanShowBannerInfo: ['administrator'],
}